





/**
 * @ignore
 * Makes sure that GeopolView object returns the same view code as provided in constructor. It means that this is a
 * correct view code because otherwise GeopolView would fallback to default one.
 */
define(['./geopolView'], function(GeopolView) {
    'use strict';
    return function(geopolViewCode, serviceType, subType) {
        var geopolView = new GeopolView(geopolViewCode);
        return geopolView.getValueFor(serviceType, subType) === geopolViewCode;
    };
});



// WEBPACK FOOTER //
// ./config/geopolView/validator.js